module.exports = __webpack_public_path__ + "img/icn_arrow.d20a6f79.svg";